import { render, staticRenderFns } from "./InvoiceSupplier.vue?vue&type=template&id=712aee56&"
import script from "./InvoiceSupplier.vue?vue&type=script&lang=js&"
export * from "./InvoiceSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports